<template>
  <div v-if="loginMode === 'names'" class="flex flex-col items-center pt-16 overflow-hidden">
    <div class="text-3xl text-center text-n-0 font-text font-bold mb-2 px-4">
      {{ isAttendanceMode ? t('employees.attendance.title') : t('employees.title') }}
    </div>
    <div
      class="overflow-scroll scrolling-touch gap-4 p-4 max-w-[33.5rem]"
      :class="[
        currentList.length < 3 ? 'flex flex-row items-center' : 'grid grid-cols-2 sm:grid-cols-3'
      ]"
    >
      <employee-card v-for="employee in currentList" :key="employee.id" :employee="employee" />
    </div>
  </div>
  <div v-if="loginMode === 'pin'" class="flex flex-col items-center h-full flex-1 pt-16">
    <div class="text-3xl text-center text-n-0 font-text font-bold">
      {{ t('employees.pin-title') }}
    </div>
    <pin-pad class="mt-6" @complete="pinEntered" />
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import PinPad from '@/components/PinPad.vue'
import { useAuthStore } from '@/store/auth'
import { useEmployeeStore } from '@/store/employee'
import type { Employee } from '@/types'

import EmployeeCard from './EmployeeCard.vue'

const { t } = useI18n()

const employeeStore = useEmployeeStore()
const { isAttendanceMode, loginMode } = storeToRefs(employeeStore)
const { pinEntered } = employeeStore

const authStore = useAuthStore()
const { posAccessEmployees, listEmployees } = storeToRefs(authStore)

const currentList = computed<Employee[]>(() =>
  isAttendanceMode.value ? listEmployees.value : posAccessEmployees.value
)
</script>
